import { FileTitle } from '../mfilesConfig/mfilesConfig.initialState';

interface SheetConfigState {
  sheetConfig: {
    existingPropIds: string[];
  };
  activeSheetName: string;
  isLoader: boolean;
  isError: boolean;
  errorMessage: string;
  adminColumns: AdminProp[];
  requiredAdminColumns: string[];
  data: {
    fileTitle: FileTitle[];
  };
}

type AdminProp = {
  Title: string;
};

const adminPropArray: AdminProp[] = [
  { Title: 'WebView' },
  { Title: 'vNextWebView' },
  { Title: 'DesktopView' },
  { Title: 'DesktopOpen' },
  { Title: 'Size On Server' },
  { Title: 'Last modified' },
  { Title: 'GUID' },
  { Title: 'ID' },
  { Title: 'Object Type' },
  { Title: 'Object Name' },
  { Title: 'Object Class' },
  { Title: 'Class Name' },
  { Title: 'Modified' },
  { Title: 'Update Status' },
  { Title: 'Updated Message' },
  { Title: 'Created' },
  { Title: 'Created by' },
  { Title: 'Status changed' },
  { Title: 'Object changed' },
  { Title: 'Single file' },
  { Title: 'Class groups' },
  { Title: 'Size on server (this version)' },
  { Title: 'Size on server (all versions)' },
  { Title: 'Marked for archiving' },
  { Title: 'Last modified by' },
  { Title: 'Version' },
  { Title: 'Workflow' },
  { Title: 'State' },
];

const requiredAdminPropArray: string[] = [
  'GUID',
  'ID',
  'Object Type',
  'Object Name',
  'Object Class',
  'Class Name',
  'Modified',
  'Update Status',
  'Updated Message',
];

export const sheetConfigInitialState: SheetConfigState = {
  sheetConfig: {
    existingPropIds: [],
  },
  activeSheetName: '',
  adminColumns: adminPropArray,
  requiredAdminColumns: requiredAdminPropArray,
  isLoader: false,
  isError: false,
  errorMessage: '',
  data: {
    fileTitle: [],
  },
};
